import React from "react";
import {Container} from "@/shared/components/shared";
import Image from "next/image";

export const SeeOnce: React.FC = () => {
    return (
        <>
            <section className={'relative h-[535px] lg:h-[952px]'}>
                <div className="absolute inset-0">
                    <Image
                        src="/images/see-once.jpg"
                        alt="Интерьер комнаты ожидания"
                        fill
                        className="object-cover object-center"
                    />
                </div>
                <div
                    className="absolute inset-0 bg-gradient-to-b from-[rgba(38,38,38,0.76)] from-10.56% via-transparent via-5.11% to-transparent bg-blend-multiply"/>
                <div className="relative z-10 flex h-full items-start pt-12 lg:pt-30">
                    <Container className={'mx-auto'}>
                        <h2 className={'text-white font-bold text-[30px] lg:text-[70px] uppercase leading-[1.2]'}>
                            Лучше один раз увидеть,<br className={'hidden lg:block'}/> чем сто раз услышать
                        </h2>
                        <p className={'text-white text-2xl lg:text-[45px] uppercase mt-5 lg:mt-7'}>Приезжайте и почувствуйте разницу!</p>
                    </Container>
                </div>
            </section>
            <section className={'bg-custom-black'}>
                <Container className={'pt-14 lg:pt-34 pb-19 lg:pb-35'}>
                    <h2 className={'font-bold text-custom-orange text-[30px] lg:text-[70px] uppercase md:text-center leading-[1.2]'}>нам
                        есть, чем вас приятно удивить</h2>
                    <p className={'font-bold text-white text-[30px] lg:text-[70px] uppercase md:text-center leading-[1.2]'}>До
                        встречи!</p>
                </Container>
            </section>
        </>
    );
}